import React, { Component } from 'react';
import { connect } from "react-redux";
import { bankAction } from "../../../store/actions/file-conversion/bank";
import { Buffer } from 'buffer'
import './style.scss';
import FileUpload from '../../../components/file-upload';
class BankUploadsView extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {

  }

  state = {
    src: null,
    file: null,
    fileConvertError: false,
    bankFileName: null,
    dragging: false,
  };

  onSelectFileBankUpload = (e, drop) => {

    e.preventDefault();
    let file = drop ? e.dataTransfer.files[0] : e.target.files[0];
    if (!file) return;
    let reader = new FileReader();
    this.setState({
      file: file,
      fileConvertError: null,
      bankFileName: file.name,
    });
    // reader.readAsText(file);
    reader.readAsDataURL(file);
    reader.onload = (res) => this.setState({ src: res.target.result });
  };

  uploadFile = async (fileInput) => {
    const i = this.state.src.indexOf("base64,");
    const buffer = Buffer.from(this.state.src.slice(i + 7), "base64");
    const file = new File([buffer], "name", {
      type: "application/vnd.ms-excel",
    });

    const fd = new FormData();
    fd.append("file", file);
    fd.append("filename", file.name);

    await this.props.bankAction(fd);
    let result = this.props.BankReducer;
    if (result === undefined && result.msg === "Error converting file") {
      return this.setState({ fileConvertError: result.msg });
    }
    const url = window.URL.createObjectURL(
      new Blob([result], { type: "application/*" })
    );

    fileInput.current.value = null;

    this.setState({
      src: null,
      bankFileName: "",
    });

    var link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `bank-upload.csv`);
    document.body.appendChild(link);
    link.click();

  };

  render() {
    return (
      <FileUpload
        HtmlFor="upld_file"
        FileError={this.state.fileConvertError}
        CAPTION="BANK UPLOAD"
        OnSelectFile={this.onSelectFileBankUpload}
        UploadFile={this.uploadFile}
        Color="#001374"
        Accept=".csv,.txt"
      />
    );
  }
}
const mapStateToProps = ({ UserReducer, BankReducer }) => ({ UserReducer, BankReducer });

export default connect(mapStateToProps, { bankAction })(BankUploadsView);